import { Outlet } from "react-router-dom";
import RunList from "./RunList";
import RunComposition from "./RunComposition";

export const adminRunsRoutes = [
  {
    path: "runs",
    element: Outlet,
    children: [
      {
        path: "",
        element: RunList,
      },
      {
        path: "list",
        element: RunList,
      },
      {
        path: ":id/composition",
        element: RunComposition,
      },
    ],
  },
];
